import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { RegulatoryDialogComponent, RegulatoryCautionItem } from './regulatory-dialog.component';
import { REGULATORY_DISCLAIMER_TEXT } from '@app/_shared/strings';

export interface RegulatoryData {
  symbol: string;
  company_name?: string;
  regulatory_messages: string[];
}

/**
 * Service to handle regulatory confirmation dialogs.
 * Centralizes the logic for checking broker regulation status and showing regulatory caution dialogs.
 */
@Injectable({
  providedIn: 'root'
})
export class RegulatoryGuardService {
  constructor(private dialog: MatDialog) {}

  /**
   * Shows a regulatory confirmation dialog if the portfolio contains regulated symbols.
   * 
   * @param regulatoryData Array of regulatory data for symbols
   * @param noteText Optional custom disclaimer text (defaults to standard regulatory disclaimer)
   * @returns Promise<boolean> - true if user accepts, false if rejected
   */
  async confirmIfRegulated(
    regulatoryData: RegulatoryData[],
    noteText?: string
  ): Promise<boolean> {
    if (!regulatoryData || regulatoryData.length === 0) {
      return true;
    }

    try {
      const result = await this.dialog.open(RegulatoryDialogComponent, {
        width: '600px',
        panelClass: 'ut-pro-dialog-box-custom-header',
        data: {
          items: regulatoryData.map((item): RegulatoryCautionItem => ({
            symbol: item.symbol,
            name: item.company_name,
            messages: item.regulatory_messages
          })),
          noteText: noteText || REGULATORY_DISCLAIMER_TEXT(false)
        }
      }).afterClosed().toPromise();
      
      return !!result;
    } catch (err) {
      console.error('Regulatory confirmation dialog error:', err);
      return false;
    }
  }
}
